import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/apiClient";
import { Sparkles, Crown } from "lucide-react";

/** Bandeau quota gratuit : "X/3 Flash Droit gratuits restants ce mois-ci" */
export function QuotaBanner() {
  const [q, setQ] = useState(null);
  useEffect(() => {
    api.get("/quota/me").then((r) => setQ(r.data)).catch(() => setQ(null));
  }, []);
  if (!q || q.premium) return null; // pas de bandeau pour les Premium
  const pct = Math.min(100, (q.free_remaining / q.free_limit_monthly) * 100);
  const critical = q.free_remaining === 0;
  return (
    <div className={`j-card ${critical ? "border-red-200 bg-red-50/60" : "border-emerald-200 bg-emerald-50/40"}`} data-testid="quota-banner">
      <div className="flex items-center gap-3 flex-wrap">
        <Sparkles className={`w-5 h-5 ${critical ? "text-red-600" : "text-[#10B981]"}`} />
        <div className="flex-1 min-w-[200px]">
          <div className={`font-heading font-black text-sm ${critical ? "text-red-900" : "text-emerald-900"}`}>
            {critical ? "Quota gratuit épuisé ce mois-ci" : `${q.free_remaining} analyse${q.free_remaining > 1 ? "s" : ""} gratuite${q.free_remaining > 1 ? "s" : ""} restante${q.free_remaining > 1 ? "s" : ""} ce mois-ci`}
          </div>
          <div className="text-xs text-slate-600 mt-0.5">
            {critical ? "Passez Premium (4,99 €/mois) ou débloquez une analyse à 1,99 €" : `${q.free_limit_monthly - q.free_remaining}/${q.free_limit_monthly} utilisés · renouvelé dans 30 jours`}
          </div>
          <div className="h-1.5 bg-slate-100 rounded-full mt-2 overflow-hidden">
            <div className="h-full transition-all" style={{ width: `${pct}%`, background: critical ? "#EF4444" : "#10B981" }} />
          </div>
        </div>
        {critical && (
          <Link to="/checkout/citoyen_premium" className="btn-emerald !py-2 !px-4 !text-sm" data-testid="quota-upgrade-btn">
            <Crown className="w-3 h-3" /> Passer Premium
          </Link>
        )}
      </div>
    </div>
  );
}
